import { ComponentSection } from '@/app/_components/core/component-section';
import { getSectionProps } from '@/app/_components/shared/utils/component-helpers';
import { cn } from '@/app/_lib/utils';
import { FormEmbed1Col } from './form-embed-1col';
import { FormEmbed2Col } from './form-embed-2col';
import type { FormEmbedComponentProps } from './form-embed.types';

const THEME_CLASS_MAP: Record<string, string> = {
  theme0: 'bg-background',
  theme1: 'bg-form-embed-accent',
};

export default function FormEmbedComponent({
  component,
  componentPosition,
  isNested,
  eventMeta,
}: FormEmbedComponentProps) {
  const { layoutType, theme } = component;
  const is1Col = layoutType === '1col';
  const themeClass = THEME_CLASS_MAP[theme] ?? THEME_CLASS_MAP.theme0;

  return (
    <ComponentSection isNested={isNested}
      {...getSectionProps(component, componentPosition, isNested)}
      className={cn(
        is1Col
          ? [
              'py-section-padding-y-mobile xl:py-section-padding-y-desktop',
              'mx-auto max-w-(--breakpoint-3xl)',
              themeClass,
            ]
          : [
              'py-section-padding-y-mobile xl:py-section-padding-y-desktop',
              'container px-0 sm:px-container-padding-x-mobile xl:px-container-padding-x-desktop',
            ]
      )}
    >
      {is1Col ? (
        <FormEmbed1Col component={component} eventMeta={eventMeta} />
      ) : (
        <FormEmbed2Col
          component={component}
          eventMeta={eventMeta}
          priorityMedia={componentPosition === 0}
        />
      )}
    </ComponentSection>
  );
}

export { FormEmbedComponent };
